<template>
    <section class="section">
        <div class="container">
            <div class="columns">
                <h1 class="title">{{ translate("admin_share_tv.title") }}</h1>
            </div>

            <div class="columns">
                <div class="column is-12">
                    <p class="mb-3 has-text-weight-bold">{{ translate("admin_share_tv.choose_mats") }}</p>
                    <MatSelectionBar ref="matSelectionBar" :event-id="eventId" @selectedMat="refreshUrls" :show-select-all="true" />
                </div>
            </div>

            <div class="columns">
                <div class="column is-12">
                    <div class="field">
                        <label class="label">
                            {{ translate("admin_share_tv.fights_queue") }}

                            <a v-if="sharingUrls.fightsQueue" class="is-pulled-right" :href="sharingUrls.fightsQueue" target="_blank">
                                {{ translate("common.open") }}
                            </a>
                        </label>

                        <div class="control">
                            <input type="text" class="input" v-model="sharingUrls.fightsQueue" />
                        </div>
                    </div>

                    <h3 class="is-size-5 has-border">{{ translate("common.options") }}</h3>

                    <div class="field">
                        <label class="label"> {{ translate("admin_share_tv.number_of_mats_to_show") }} {{ pageSize }} </label>

                        <div class="control">
                            <div>
                                <input type="range" min="1" max="10" step="1" v-model="pageSize" @change="refreshUrls" />
                            </div>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label"> {{ translate("admin_share_tv.limit_fights") }} {{ limitFights }} </label>
                        <div class="control">
                            <div>
                                <input type="range" min="1" max="100" step="1" v-model="limitFights" @change="refreshUrls" />
                            </div>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">{{ translate("admin_share_tv.color_schema") }}</label>
                        <div class="control">
                            <div class="select">
                                <select v-model="colorSchema" @change="refreshUrls">
                                    <option value="default">
                                        {{ translate("admin_share_tv.color_schema.default") }}
                                    </option>
                                    <option value="redblue">
                                        {{ translate("admin_share_tv.color_schema.redblue") }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import MatSelectionBar from "../Common/MatSelectionBar";
    import errorHandlerMixin from "../Common/errorHandlerMixin";
    import apiMixin from "../Api/apiMixin";
    import translatorMixin from "../Common/translatorMixin";

    export default {
        name: "sharing-on-tv-app",
        components: {
            MatSelectionBar,
        },
        mixins: [errorHandlerMixin, apiMixin, translatorMixin],
        props: ["eventId"],
        data() {
            return {
                sharingUrls: {},
                pageSize: 8,
                limitFights: 15,
                colorSchema: "default",
            };
        },
        mounted() {
            return this.fetchSharingUrls().catch(this.handleError);
        },
        methods: {
            fetchSharingUrls() {
                return this.sharingApi()
                    .getSharingUrls(this.eventId, this.getSelectedMats(), this.pageSize, this.limitFights, this.colorSchema)
                    .then(sharingUrls => {
                        this.sharingUrls = sharingUrls;
                    });
            },
            getSelectedMats() {
                return this.$refs.matSelectionBar.getSelectedMats();
            },
            refreshUrls() {
                return this.fetchSharingUrls().catch(this.handleError);
            },
        },
    };
</script>

<style scoped>
    .top-buffer {
        margin-top: 15px;
    }
</style>
